import { render, staticRenderFns } from "./PravnoTijelo.vue?vue&type=template&id=e306541c"
import script from "./PravnoTijelo.vue?vue&type=script&lang=js"
export * from "./PravnoTijelo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports